import { ExtensionContact } from '../interfaces/contact.interface';

// values defined for PhoneState in astimax-states
export enum ExtensionPhoneState {
	Unavailable = 0,
	Idle = 1,
	Ringing = 2,
	InUse = 3,
	Unknown = -1
}

export const EXTENSION_CONTACTS_CONSTANTS =  {
	TYPE: 'request',
	SERVICE: 'astimax-states',
	METHOD_SUBSCRIBE: 'subscribe',
	METHOD_UNSUBSCRIBE: 'unsubscribe',
	REQUEST_PHONE_STATE: 'getPhoneState',
	EVENT_TYPE: 'phoneState',
	EMIT_REQUEST: 'request',
	LISTEN_ON_RESPONSE: 'response',
	LISTEN_ON_EVENT: 'event',
	LISTEN_UPDATE: 'phoneStateUpdate',
	VERSION: '1.0',
}

export interface IPhoneStateUpdateEvent {
	id?: string;
	metadata: {
		amsaType?: string
		amsaMessageId?: string;
		clientId?: string;
		correlationId?: string;}
	method?: string;
	payload?: ExtensionContact[]
	service?: string;
	timestamp?: string;
	type?: string;
}

export interface IGetPhoneStateResponse {
	id: string;
	type: string;
	service: string;
	method: string;
	payload: ExtensionContact[];
	metadata: {
		correlationId: string;
		amsaMessageId?: string;
	}
	timestamp?: string;
}
